export const version = "ethers/5.6.7";
//# sourceMappingURL=_version.js.map